module.exports = __webpack_public_path__ + "static/media/СЗФО_2012.048ef4e6.png";